/* cart-bundle-rules.js — keep the cart free of items a bundle already covers.
   When the Plugin Suite or the Everything Bundle is in the cart, the individual
   products it contains are removed automatically (you'd otherwise pay twice).
   Pure AJAX Cart API, no app. Loaded site-wide from layout/theme.liquid.

   Runs on page load and after any add (listens for 'preset-packs:added', which
   streaky.js / preset-packs.js / st-upsell all dispatch). After it changes the
   cart it re-dispatches that event so every cart bar refreshes. */
(function () {
  'use strict';
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/+$/, '');

  // A bundle handle "supersedes" the part handles it contains.
  var RULES = [
    {
      bundle: 'streaky-everything-bundle',
      removes: ['colourbox', 'colourbox-2', 'tight-arse', 'body-builder', 'plugin-suite',
                'colourbox-tight-arse-bundle', 'body-builder-colourbox-bundle', 'body-builder-tight-arse-bundle',
                'fabfilter-saturn-2-presets', 'valhalla-vintageverb-presets-vol-2'],
      message: 'Your Everything Bundle already includes those, so we kept just the bundle.'
    },
    {
      bundle: 'plugin-suite',
      removes: ['colourbox', 'colourbox-2', 'tight-arse', 'body-builder',
                'colourbox-tight-arse-bundle', 'body-builder-colourbox-bundle', 'body-builder-tight-arse-bundle'],
      message: 'Your Plugin Suite already includes those plugins, so we kept just the Suite.'
    }
  ];

  // Extra rules injected by sections at render time (e.g. st-upsell emits one
  // for whichever bundle product is picked in the customizer), so a future
  // bundle needs no edit here. Same shape as RULES entries.
  if (Array.isArray(window.stBundleRules)) {
    window.stBundleRules.forEach(function (r) {
      if (!r || !r.bundle) return;
      var existing = null, i;
      for (i = 0; i < RULES.length; i++) {
        if (RULES[i].bundle === r.bundle) { existing = RULES[i]; break; }
      }
      if (!existing) { RULES.push(r); return; }
      /* Same bundle is already known here. The section's list comes from the
         theme editor (st-upsell's bundle_members), so it tracks product renames
         and this file does not. Dropping it was silently wrong: BodyBuilder 2
         shipped as handle 'body-builder-2' while the hardcoded list below still
         said 'body-builder', so the Suite stopped stripping it and a cart of
         Suite + BodyBuilder 2 charged 188 for 149 of product.

         So MERGE rather than discard. Union only: this can add a handle to
         strip, never remove one, so a rule can never start keeping something it
         used to remove. */
      if (!existing.removes) existing.removes = [];
      (r.removes || []).forEach(function (h) {
        if (existing.removes.indexOf(h) === -1) existing.removes.push(h);
      });
    });
  }

  /* reconcile() is awaited by callers that must not proceed until the cart is
     settled (the add-ons page redirects to checkout on it). So it RETURNS its
     promise, and when a run is already in flight it returns THAT promise rather
     than undefined: a second caller then waits for the real work instead of
     sailing past a silent no-op. Existing callers ignore the return value and
     are unaffected. */
  var running = false;
  var inflight = null;

  function toast(msg) {
    if (!msg) return;
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;top:84px;left:50%;transform:translateX(-50%) translateY(-12px);z-index:80;' +
      'background:rgba(10,10,11,.95);color:#f5f5f7;border:1px solid rgba(255,255,255,.14);border-radius:980px;' +
      'padding:11px 22px;font:600 .88rem/1.3 -apple-system,BlinkMacSystemFont,Inter,Segoe UI,Helvetica,Arial,sans-serif;' +
      'box-shadow:0 12px 40px rgba(0,0,0,.5);opacity:0;transition:opacity .2s ease,transform .2s ease;' +
      'max-width:92vw;text-align:center;';
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; }, 20);
    setTimeout(function () {
      t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(-12px)';
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 260);
    }, 3400);
  }

  function reconcile() {
    if (running) return inflight || Promise.resolve();
    running = true;
    inflight = fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var handles = items.map(function (i) { return i.handle; });
        var updates = {};
        var message = '';
        RULES.forEach(function (rule) {
          if (handles.indexOf(rule.bundle) === -1) return;
          var hit = false;
          items.forEach(function (it) {
            if (rule.removes.indexOf(it.handle) !== -1) { updates[it.key] = 0; hit = true; }
          });
          if (hit && !message) message = rule.message;
        });
        var keys = Object.keys(updates);
        if (!keys.length) { running = false; inflight = null; return; }
        return fetch(ROOT + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            running = false;
            inflight = null;
            toast(message);
            document.dispatchEvent(new CustomEvent('preset-packs:added')); // refresh cart bars
          });
      })
      .catch(function () { running = false; inflight = null; });
    return inflight;
  }

  /* The MERGED rule set, exposed so a caller can verify the cart itself rather than
     trust that reconcile ran. The add-ons page asserts against this before it lets
     anyone reach checkout. */
  window.stAllBundleRules = RULES;
  window.stReconcileCart = reconcile;
  document.addEventListener('preset-packs:added', reconcile);
  if (document.readyState !== 'loading') reconcile();
  else document.addEventListener('DOMContentLoaded', reconcile);
})();
